import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  IconButton,
  Chip,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Edit } from "@mui/icons-material";
import TableBarIcon from "@mui/icons-material/TableBar";
import TableRestaurantIcon from "@mui/icons-material/TableRestaurant";
import LocalBarIcon from "@mui/icons-material/LocalBar";
import RadioIcon from "@mui/icons-material/Radio";
import DeleteModal from "../DeleteModal/DeleteModal";
import { fetchWithAuth } from "../../../utils/fetchWithAuth";
import "./TableCard.css";
import PersonIcon from "@mui/icons-material/Person";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

const API = process.env.REACT_APP_API_BASE;

const typeIcons = {
  round: <TableBarIcon fontSize="large" />,
  square: <TableRestaurantIcon fontSize="large" />,
  standing: <LocalBarIcon fontSize="large" />,
  band: <RadioIcon fontSize="large" />,
  bridal: <TableRestaurantIcon fontSize="large" />,
};

const TableCard = ({
  id,
  number,
  name,
  type,
  takenSeats,
  availableSeats,
  onEdit,
  onDelete,
}) => {
  const [deleteOpen, setDeleteOpen] = useState(false);

  const handleDeleteClick = () => setDeleteOpen(true);

  const handleConfirmDelete = async () => {
    try {
      const response = await fetchWithAuth(`${API}/tables/${id}`, {
        method: "DELETE",
      });
      if (!response.ok) throw new Error("Failed to delete table");
      onDelete(id);
    } catch (error) {
      console.error("Error deleting table:", error);
    }
  };

  return (
    <>
      <Card className="table-card">
        <CardContent className="table-card-content">
          <Box className="table-left">
            <Box className="table-icon-wrapper">
              {typeIcons[type] || <TableBarIcon fontSize="large" />}
            </Box>
            <Box>
              <Typography className="table-name">{name}</Typography>
              <Box mt={1} gap={1} className="chips">
                <Chip
                  label={`Маса бр. ${number}`}
                  size="small"
                  className="table-number"
                />
                <Chip
                  size="small"
                  className="seats-chip"
                  label={
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <PersonIcon fontSize="small" />
                      <span>{takenSeats}</span>
                    </Box>
                  }
                />
                <Chip
                  size="small"
                  className="seats-chip"
                  label={
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <PersonOutlineIcon fontSize="small" />
                      <span>{availableSeats}</span>
                    </Box>
                  }
                />
              </Box>
            </Box>
          </Box>

          <Box className="table-actions">
            <IconButton
              onClick={() =>
                onEdit({ id, number, name, type, takenSeats, availableSeats })
              }
            >
              <Edit />
            </IconButton>
            <IconButton onClick={handleDeleteClick}>
              <DeleteIcon />
            </IconButton>
          </Box>
        </CardContent>
      </Card>

      <DeleteModal
        open={deleteOpen}
        onClose={() => setDeleteOpen(false)}
        onConfirm={handleConfirmDelete}
      />
    </>
  );
};

export default TableCard;
